/*
  © 2024 KondaSoft
  https://www.kondasoft.com
*/

function zoom(e){
  var zoomer = e.currentTarget;
  e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
  e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
  x = offsetX/zoomer.offsetWidth*100
  y = offsetY/zoomer.offsetHeight*100
  zoomer.style.backgroundPosition = x + '% ' + y + '%';
}

function toggleZoom(e) {
  e.currentTarget.classList.toggle('active');
}

// Init Bootstrap tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]')
  .forEach((el) => new window.bootstrap.Tooltip(el))

// Init Bootstrap popovers
document.querySelectorAll('[data-bs-toggle="popover"]')
  .forEach((el) => new window.bootstrap.Popover(el))

// Debouce
window.theme.debounce = function (callback, wait = 200) {
  let timeout
  return (...args) => {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => callback.apply(context, args), wait)
  }
}

// Throttle
window.theme.throttle = function (callback, timeFrame = 200) {
  let lastTime = 0
  return function () {
    const now = Date.now()
    if (now - lastTime >= timeFrame) {
      callback()
      lastTime = now
    }
  }
}

// Create cookie
window.theme.createCookie = function (name, value, days) {
  let date, expires
  if (days) {
    date = new Date()
    date.setDate(date.getDate() + days)
    expires = '; expires=' + date.toUTCString()
  } else {
    expires = ''
  }
  document.cookie = name + '=' + value + expires + '; path=/'
}

//Detect scroll
window.addEventListener('scroll', () => {
  if (window.scrollY > 0) {
    document.documentElement.classList.add('has-scrolled')
  } else {
    document.documentElement.classList.remove('has-scrolled')
  }
})

// Calculate "xx time ago"
window.theme.calcTimeAgo = function (timestamp) {
  const now = new Date().getTime()
  const diff = now - timestamp

  let text

  if (diff < 60000) {
    text = window.theme.locales.times.moments
  } else if (diff < 3.6e+6) {
    const min = Math.round((diff) / 60000)
    text = min === 1
      ? `${min} ${window.theme.locales.times.minute}`
      : `${min} ${window.theme.locales.times.minutes}`
  } else if (diff < 8.64e+7) {
    const hours = Math.round((diff) / 3.6e+6)
    text = hours === 1
      ? `${hours} ${window.theme.locales.times.hour}`
      : `${hours} ${window.theme.locales.times.hours}`
  } else {
    const days = Math.round((diff) / 8.64e+7)
    text = days === 1
      ? `${days} ${window.theme.locales.times.day}`
      : `${days} ${window.theme.locales.times.days}`
  }

  return `${text} ${window.theme.locales.times.ago}`
}

// Format money
window.Shopify.formatMoney = function (cents, moneyFormat = window.Shopify.moneyFormat) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '')
  }

  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/

  function defaultOption (opt, def) {
    return (typeof opt === 'undefined' ? def : opt)
  }

  function formatWithDelimiters (number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split('.')
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
    const cents = parts[1] ? (decimal + parts[1]) : ''

    return dollars + cents
  }

  switch (moneyFormat.match(placeholderRegex)[1]) {
  case 'amount':
    value = formatWithDelimiters(cents, 2)
    break
  case 'amount_no_decimals':
    value = formatWithDelimiters(cents, 0)
    break
  case 'amount_with_comma_separator':
    value = formatWithDelimiters(cents, 2, '.', ',')
    break
  case 'amount_no_decimals_with_comma_separator':
    value = formatWithDelimiters(cents, 0, '.', ',')
    break
  }

  return moneyFormat.replace(placeholderRegex, value)
}

// Resize images
window.Shopify.resizeImage = function (src, size, crop = '') {
  return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
      if (crop.length) {
        crop = `_crop_${crop}`
      }
      return `_${size}${crop}${match}`
    })
}

// Shopify's callenge page
document.querySelector('.btn.shopify-challenge__button')
  ?.classList.add('btn-primary')

// Shopify's errors messages
const errors = document.querySelector('.errors')
if (errors) {
  errors.classList.add('alert', 'alert-danger')
}

// Wrap Shopify's section apps within a container
document.querySelectorAll('.shopify-section > .shopify-app-block').forEach(elem => {
  elem.classList.add('container')
})

// Detect viewport with the Intersection Observer API
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('viewport-entered')
    } else {
      entry.target.classList.remove('viewport-entered')
    }
  })
}, { threshold: 0.4 })

document.querySelectorAll('.viewport-detect').forEach((el) => {
  observer.observe(el)
})

// Swiper Slider
class SwiperSlider extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init()
      }
    })
  }

  init () {
    this.slider = new window.Swiper(this.querySelector('.swiper'), {
      speed: this.speed,
      autoplay: this.autoplay,
      navigation: this.navigation,
      pagination: this.pagination,
      scrollbar: this.scrollbar,
      breakpoints: this.breakpoints,
      rewind: true
    })
  }

  speed = Number(this.dataset.sliderSpeed)

  autoplay = this.dataset.sliderAutoplay === '0'
    ? undefined
    : { delay: Number(this.dataset.sliderAutoplay) * 1000 }

  navigation = {
    enabled: this.dataset.sliderNavigation === 'true',
    prevEl: '.swiper-button-prev',
    nextEl: '.swiper-button-next'
  }

  pagination = {
    enabled: this.dataset.sliderPagination === 'true',
    el: '.swiper-pagination',
    type: 'bullets',
    dynamicBullets: true,
    dynamicMainBullets: 2,
    renderFraction: function (currentClass, totalClass) {
      return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
    }
  }

  scrollbar = {
    enabled: this.dataset.sliderScrollbar === 'true',
    el: this.querySelector('.swiper-scrollbar'),
    draggable: true
  }

  breakpoints = {
    0: { slidesPerView: Number(this.dataset.breakpointMobile) },
    600: { slidesPerView: Number(this.dataset.breakpointTablet) },
    1200: { slidesPerView: Number(this.dataset.breakpointDesktop) }
  }
}
customElements.define('swiper-slider', SwiperSlider)

/*
  Localization form
*/
document.querySelectorAll('.shopify-localization-form button').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('form').querySelector('[name="country_code"]').value = btn.dataset.isoCode
    btn.closest('form').submit()
  })
})


document.addEventListener("DOMContentLoaded", function() {
  // Function to set a cookie
  function setCookie(name, value, days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  // Function to get a cookie
  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
  }

  // Check if the preloader cookie exists
  var preloaderDisplayed = getCookie("preloaderDisplayed");
  if ($('.page-type-index').length) {
    if (!preloaderDisplayed) {
        var logoAnimated = document.getElementById("Logo-1");
        var preloader = document.getElementById("preloader");
        
        if (preloader) {
            logoAnimated.style.display = "block";

            // Hide the preloader after a delay (e.g., 3 seconds)
            setTimeout(function() {
                preloader.style.display = "none";
                logoAnimated.style.zIndex = "0";
                setCookie("preloaderDisplayed", "true", 7); // Set the cookie for 30 days
            }, 4000);
        }
    } else {
      var preloader = document.getElementById("preloader");
      var logoHero = document.getElementById("logo-2");
      logoHero.style.display = "block";
      preloader.style.display = "none";
    }
  } else {
    var preloader = document.getElementById("preloader");
    preloader.style.display = "none";
  }
});

/*document.addEventListener('DOMContentLoaded', () => {

  const form = document.querySelector('form[action="/cart/add"]');

  if (!form) return;

  const modal = document.getElementById('fulfillment-modal');

  //const hiddenInput = document.getElementById('fulfillment-method');

  const addButton = form.querySelector('[type="submit"]');

  if (!addButton) return;

  const productTags = document
    .getElementById('product-tags')
    ?.dataset.tags || '';

  const requiresChoice = productTags.includes(
    'requires-fulfillment-choice'
  );

  if (!requiresChoice) return;

  let fulfillmentSelected = false;

  // INTERCEPT BUTTON CLICK BEFORE THEME AJAX
  addButton.addEventListener('click', function(e) {

    // already selected → allow normal add to cart
    if (fulfillmentSelected) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    modal.classList.remove('hidden');

  }, true);

  // HANDLE MODAL CHOICE
  document.querySelectorAll('.fulfillment-choice')
    .forEach(button => {

      button.addEventListener('click', () => {

        //hiddenInput.value = button.dataset.value;

        fulfillmentSelected = true;

        modal.classList.add('hidden');

        // trigger actual add to cart
        addButton.click();

      });

  });

  // CLOSE MODAL
  document.querySelector('.fulfillment-modal__close')
    ?.addEventListener('click', () => {

      modal.classList.add('hidden');

  });

});*/


document.addEventListener('DOMContentLoaded', () => {

  const form =
    document.querySelector('form[action="/cart/add"]');

  if (!form) return;

  const modal =
    document.getElementById('fulfillment-modal');

  const note =
    document.getElementById('fulfillment-note');

  const addButton =
    form.querySelector('[type="submit"]');

  if (!addButton) return;

  const productTags =
    document.getElementById('product-tags')
      ?.dataset.tags || '';

  const requiresChoice =
    productTags.includes('requires-fulfillment-choice');

  const requiresChoiceAntiques =
    productTags.includes('requires-fulfillment-antiques');

  const requiresChoiceDecor =
    productTags.includes('requires-fulfillment-decor');

  if (!requiresChoice && !requiresChoiceAntiques && !requiresChoiceDecor) return;

  if (requiresChoiceAntiques) {
    note.innerHTML = 'Shipping costs vary by destination and cannot be confirmed at checkout. Please allow 2–4 weeks for shipment preparation. Following your purchase, the Galerie Solis team will be in touch with a personalised quote.<br><br>By proceeding, you accept responsibility for any freight costs incurred.'
  } else if (requiresChoiceDecor) {
    note.innerHTML = 'Our pillows are made to order using in-stock fabrics, with a 2–3 week lead time. The Galerie Solis team will be in touch when your order is ready to ship.'
  }

  //INTERCEPT ADD TO CART
  addButton.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    modal.classList.remove('hidden');
  }, true);

  //MODAL CONFIRM
  document.querySelectorAll('.fulfillment-choice')
    .forEach(button => {

      button.addEventListener('click', async () => {

        modal.classList.add('hidden');

        try {
          // ADD MAIN PRODUCT (THEME AJAX SYSTEM)
          const formData = new FormData(form);

          formData.append(
            'sections',
            ['cart-count-badge', 'offcanvas-cart']
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          const mainRes = await fetch(
            `${window.Shopify.routes.cart_add_url}.js`,
            {
              method: 'POST',
              body: formData
            }
          );

          const mainData = await mainRes.json();

          if (!mainRes.ok) {
            throw new Error(
              mainData.description || 'Main product failed'
            );
          }

          //CANOPY CHECK
          const canopyEnabled =
            document.getElementById('CanopyToggle')
              ?.value === 'Yes';

          if (!canopyEnabled) {

            updateCartUI(mainData.sections);
            openCartDrawer();

            return;
          }

          //GET SIZE + FABRIC
          const size =
            document.getElementById('CanopySize')
              ?.value;

          const fabric =
            document.getElementById('CanopyFabric')
              ?.value;

          if (!size || !fabric) {
            console.warn('Missing canopy size or fabric');
          } else {

            //VARIANT MAP (YOUR DATA)
            const canopyVariantMap = {
              "Queen-Chalk Linen": 52079412347111,
              "Queen-Bone Linen": 52079412379879,
              "Queen-Mushroom Linen": 52079412412647,
              "Queen-Tobacco Linen": 52079412445415,
              "Queen-Faded Black Linen": 52079412478183,
              "Queen-Lake Linen": 52079412510951,

              "King-Chalk Linen": 52079412543719,
              "King-Bone Linen": 52079412576487,
              "King-Mushroom Linen": 52079412609255,
              "King-Tobacco Linen": 52079412642023,
              "King-Faded Black Linen": 52079412674791,
              "King-Lake Linen": 52079412707559,

              "Cal-King-Chalk Linen": 52081312628967,
              "Cal-King-Bone Linen": 52081312661735,
              "Cal-King-Mushroom Linen": 52081312694503,
              "Cal-King-Tobacco Linen": 52081312727271,
              "Cal-King-Faded Black Linen": 52081312760039,
              "Cal-King-Lake Linen": 52081312792807
            };

            const key = `${size}-${fabric}`;
            const canopyVariantId = canopyVariantMap[key];

            if (!canopyVariantId) {

              console.warn(
                'No canopy variant found for:',
                key
              );
            } else {
              //ADD CANOPY (THEME AJAX SYSTEM)
              const canopyFormData = new FormData();

              canopyFormData.append('id', canopyVariantId);
              canopyFormData.append('quantity', 1);

              canopyFormData.append(
                'sections',
                ['cart-count-badge', 'offcanvas-cart']
              );

              canopyFormData.append(
                'sections_url',
                window.location.pathname
              );

              const canopyRes = await fetch(
                `${window.Shopify.routes.cart_add_url}.js`,
                {
                  method: 'POST',
                  body: canopyFormData
                }
              );

              const canopyData = await canopyRes.json();

              if (!canopyRes.ok) {
                throw new Error(
                  canopyData.description || 'Canopy failed'
                );
              }

              updateCartUI(canopyData.sections);
            }
          }

          //OPEN CART DRAWER
          openCartDrawer();

        } catch (error) {
          console.error('Cart error:', error);
        }
      });
    });
  
    //CART UI HELPERS (THEME SAFE)
  function updateCartUI(sections) {
    const cart = document.querySelector('cart-container');

    if (cart && sections) {
      cart.reloadCartElements(sections);
    }
  }

  function openCartDrawer() {
    const offcanvas =
      document.querySelector('#offcanvas-cart');

    if (offcanvas && window.bootstrap) {
      bootstrap.Offcanvas
        .getOrCreateInstance(offcanvas)
        .show();
    }
  }

  //CLOSE MODAL
  document.querySelector(
    '.fulfillment-modal__close'
  )?.addEventListener('click', () => {

    modal.classList.add('hidden');
  });
});

document.addEventListener('submit', async function (e) {
  const form = e.target.closest('.sample-atc-form');
  if (!form) return;

  e.preventDefault();

  const btn = form.querySelector('.sample-atc-btn');
  const id = form.querySelector('[name="id"]').value;

  try {

    const formData = new FormData();
    formData.append('id', id);
    formData.append('quantity', 1);

    //match theme system
    formData.append('sections', ['cart-count-badge', 'offcanvas-cart']);
    formData.append('sections_url', window.location.pathname);

    const res = await fetch(`${window.Shopify.routes.cart_add_url}.js`, {
      method: 'POST',
      body: formData
    });

    const data = await res.json();

    if (!res.ok) throw new Error(data.description || 'Add failed');

    // UI feedback
    btn.textContent = 'Added!';
    setTimeout(() => btn.textContent = 'Add to Cart', 1200);

    const cart = document.querySelector('cart-container');
    if (cart && data.sections) {
      cart.reloadCartElements(data.sections);
    }

    // ensure drawer opens like theme expects
    const offcanvas = document.querySelector('#offcanvas-cart');
    if (offcanvas && window.bootstrap) {
      bootstrap.Offcanvas.getOrCreateInstance(offcanvas).show();
    }

  } catch (err) {
    console.error(err);
    btn.textContent = 'Error';
    setTimeout(() => btn.textContent = 'Add to Cart', 1200);
  }
});